module.exports = __webpack_public_path__ + "img/Graph.5b0a0080.svg";